import { PurchaseDocumentDetail } from '../../../../app/models/PurchaseDocumentDetail';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import TaxDocumentFilter from './PurchaseDocumentFilter';
import { PurchaseDocumentDetailFilters } from '../../../../app/models/PurchaseDocumentDetail';
import { PaymentStatusDataForm, PaymentStatusesStatus } from '../../../../app/models/PaymentStatus';
import PaymentStatusChangeStatus from '../../../PaymentStatus/components/PaymentStatusChangeStatus';
import { Link } from 'react-router-dom';

interface Props {
    purchaseDocumentDetail: PaymentStatusDataForm[];
    totalRows: number;
    loading?: boolean;
    filter: PurchaseDocumentDetailFilters;
    setFilter: (filter: PurchaseDocumentDetailFilters) => void;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    callbackSuccess: () => void;
    statuses: PaymentStatusesStatus[];

}

const PurchaseDocumentDetailDataTable = ({
    purchaseDocumentDetail = [],
    totalRows,
    loading = false,
    filter,
    setFilter,
    edit,
    destroy,
    show,
    callbackSuccess,
    statuses,
}: Props) => {
console.log(purchaseDocumentDetail)
    const columns = [

        {
            name: 'Glosa',
            selector: (row: PurchaseDocumentDetail) => row.item,
            sortable: false,
            sortField: 'item',
            cell: (row: PurchaseDocumentDetail) => <span>{row.item}</span>
        },

        ...(purchaseDocumentDetail.some((row) => row.service_manifest_id) ? [
            {
                name: 'Hoja de Entrada',
                selector: (row: PurchaseDocumentDetail) => row.service_manifest_id,
                sortable: true,
                sortField: 'service_manifest_id',
                cell: (row: PurchaseDocumentDetail) => (
                    row.service_manifest_id 
                        ? <Link to={'/service-manifests/' + row?.service_manifest_id + '/show'}>
                            <span className="text-primary">#{row?.service_manifest_id}</span>
                        </Link> 
                        : <></>
                ),
            }
        ] : []),

        {
            name: 'Neto',
            selector: (row: PurchaseDocumentDetail) => row.total_neto,
            sortable: true,
            sortField: 'total_neto',
            cell: (row: PurchaseDocumentDetail) => <span>{row.total_neto}</span>
        },
        {
            name: 'Impuesto',
            selector: (row: PurchaseDocumentDetail) => row.total_tax,
            sortable: true,
            sortField: 'total_tax',
            cell: (row: PurchaseDocumentDetail) => <span>{row.total_tax}</span>
        },
        {
            name: 'Total',
            selector: (row: any) => row.total,
            sortable: true,
            sortField: 'total',
            cell: (row: any) => <span>{row.total}</span>
        },

         // Condicional para la columna Estado
        ...(purchaseDocumentDetail.some((row) => row.status) ? [
            {
                name: 'Estado',
                selector: (row: any) => row?.status,
                sortable: true,
                sortField: 'status',
                cell: (row: any) =>
                    row?.status ? (
                        <div>
                            <PaymentStatusChangeStatus
                                paymentStatusId={row.id!}
                                statuses={row.statuses || []}
                                selectedStatus={row.status}
                                callbackSuccess={callbackSuccess}
                            />
                        </div>
                    ) : (
                        <></>
                    ),
            }
        ] : []),
        {
            name: 'Acciones',
            selector: (row: PurchaseDocumentDetail) => row.id,
            sortable: false,
            cell: (row: PurchaseDocumentDetail) => (
                <div>
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.service_manifest_id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            {/* <div className="row mt-3">
                <div className="col">
                    <TaxDocumentFilter filter={filter} setFilter={setFilter} />
                </div>
            </div> */}

            <DefaultDataTable
                columns={columns}
                data={purchaseDocumentDetail}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default PurchaseDocumentDetailDataTable;
